/* RESPONSIBLE TEAM: team-messenger */
import Model, { attr, belongsTo, type SyncHasMany } from '@ember-data/model';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type TimeInterval from './matching-system/timetable/time-interval';
import type OfficeHoursSchedule from './office-hours-schedule';

export type ExceptionType = 'closed' | 'custom_hours';

export default class OfficeHoursException extends Model {
  @attr('string') declare exceptionDate: string;
  @attr('string') declare exceptionType: ExceptionType;
  @attr('string') declare name: string | null;
  @attr('boolean') declare recurringAnnually: boolean;

  @belongsTo('office-hours-schedule', { async: false, inverse: null })
  declare officeHoursSchedule: OfficeHoursSchedule;

  @fragmentArray('matching-system/timetable/time-interval')
  declare timeIntervals: SyncHasMany<TimeInterval>;

  get isClosed(): boolean {
    return this.exceptionType === 'closed';
  }

  get isCustomHours(): boolean {
    return this.exceptionType === 'custom_hours';
  }

  get displayName(): string {
    if (this.name) {
      return this.name;
    }
    return this.exceptionDate;
  }
}
